import React from "react";
import Select from "react-select";

const CustomDropdownIndicator = props => {
  return (
    <div
      className="pe-[10px]"
      {...props.innerProps}
      style={{ cursor: "pointer" }}
    >
      {/* Replace this with your custom icon */}
      <svg
        aria-label="dropdown"
        width="8"
        height="6"
        viewBox="0 0 8 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.266602 0.399902H7.73327L3.99994 5.1999L0.266602 0.399902Z"
          fill="#5A5A5A"
        />
      </svg>
    </div>
  );
};

const CustomOption = props => {
  const { data, innerRef, innerProps, isFocused, isSelected } = props;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`flex items-center text-black gap-2 px-3 py-2 cursor-pointer ${
        isFocused ? "bg-[#E4EBD4]" : ""
      }`}
      style={{
        backgroundColor: isSelected
          ? "#E4EBD4"
          : isFocused
            ? "#E4EBD4"
            : "#FBFBFB",
        borderRadius: 10,
        border: isSelected ? "1px solid black" : "",

        fontSize: 16,
      }}
    >
      {data.icon && (
        <img
          src={data.icon}
          alt={data.label}
          style={{ width: 20, height: 14, objectFit: "cover", borderRadius: 2 }}
        />
      )}
      <span>{data.label}</span>
    </div>
  );
};

const CustomSingleValue = ({ data, innerRef, innerProps }) => {
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex items-center gap-2"
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        padding: 0,
        margin: 0,

        fontSize: 16,
        color: "#000",
      }}
    >
      {data.icon && (
        <img
          src={data.icon}
          alt={data.label}
          style={{
            width: 18,
            height: 12,
            objectFit: "cover",
            borderRadius: 2,
          }}
        />
      )}
      <span>{data.label}</span>
    </div>
  );
};

const Dropdown = ({
  options,
  changeHandler,
  value,
  placeholder,
  isIconLeft = false,
  isDisabled = false,
}) => {
  const fontSizeClass = "text-[12px] md:text-14 w-full   pulse-dropdown  ";

  const customStyle = () => {
    return {
      control: (baseStyles, state) => ({
        ...baseStyles,
        border: state.isFocused ? "2px solid #C11E69" : "none",
        boxShadow: "none",
        display: "flex",
        flexDirection: isIconLeft ? "row-reverse" : "row",
        outline: "none",
        borderRadius: 10,

        background: "white",
        minHeight: "40px",
        height: "40px",
        "&:hover": {
          border: "2px solid #C11E69",
          boxShadow: "none",
        },
      }),
      dropdownIndicator: baseStyles => ({
        ...baseStyles,
        color: "#5A5A5A",
      }),
      indicatorSeparator: () => ({
        display: "none",
      }),
      menu: baseStyles => ({
        ...baseStyles,
        background: "#FBFBFB",
        color: "red",

        bordeRadius: 0,
      }),

      option: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: state.isSelected ? "#F2EDFF" : "#FBFBFB",
        color: state.isSelected ? "black" : "black",

        ":active": {
          backgroundColor: "#E4EBD4",
          color: "#000",
          border: "1px solid black",
        },
        ":hover": {
          backgroundColor: "#E4EBD4",
          color: "#000",
          border: "1px solid black",
        },
        overflow: "hidden",
        textOverflow: "ellipsis",
        borderRadius: 10,
        fontSize: 16,
      }),
      singleValue: baseStyles => ({
        ...baseStyles,
        color: "black",

        display: "flex",
      }),
      input: baseStyles => ({
        ...baseStyles,
        color: "#5A5A5A",

        borderRadius: 0,
      }),
      valueContainer: base => ({
        ...base,
        paddingInline: 10,
        display: "flex",
        alignItems: "center",
        height: "100%",
      }),
    };
  };

  return (
    <Select
      value={value}
      onChange={changeHandler}
      options={options}
      placeholder={placeholder || "Select your choice"}
      styles={customStyle()}
      components={{
        DropdownIndicator: CustomDropdownIndicator,
        Option: CustomOption,
        SingleValue: CustomSingleValue,
      }}
      isSearchable={false}
      className={fontSizeClass}
      isDisabled={isDisabled}
    />
  );
};

export default Dropdown;
